import { render, staticRenderFns } from "./PostFormMentionsLegalesSelect.vue?vue&type=template&id=5f80bd12&scoped=true&"
import script from "./PostFormMentionsLegalesSelect.vue?vue&type=script&lang=js&"
export * from "./PostFormMentionsLegalesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f80bd12",
  null
  
)

export default component.exports